document.addEventListener("DOMContentLoaded", () => {
  // 個人用フォームかどうかを判定し、個人向けの処理だけを後半で実行します。
  const isPersonalForm = Boolean(document.getElementById("for_personal"));

  // Contact Form 7 Multi-Step の次ページURLが相対パスの場合、現在のドメインを補完します。
  const multistepEl = document.querySelector(".wpcf7-multistep");
  if (multistepEl && multistepEl.value) {
    try {
      const multistep = JSON.parse(multistepEl.value);
      if (multistep.next_url && !multistep.next_url.startsWith("http")) {
        const separator = multistep.next_url.startsWith("/") ? "" : "/";
        multistep.next_url =
          window.location.origin + separator + multistep.next_url;

        multistepEl.value = JSON.stringify(multistep).replace(/\//g, "\\/");
      }
    } catch (error) {
      console.error("Multistep JSON parse error:", error);
    }
  }

  const wdSettings = window.wdFormSettings || {};
  const courseSettings = Array.isArray(wdSettings.courses)
    ? wdSettings.courses
    : [];
  const personalDateFieldNames = [
    "your-camera-consult-date1",
    "your-camera-consult-date2",
    "your-chosendate1",
    "your-chosendate2",
    "your-chosendate3",
  ];
  // 管理画面から渡されたコース設定と、連動させるセレクト要素を取得します。
  const courseCategoryEl = document.querySelector(".wpcf7-courses");
  const affiliationEl = document.querySelector(".wpcf7-affiliations");
  const courseItemEl = document.querySelector(".wpcf7-courseitems");
  const courseFlowSections = {
    affiliation: document.getElementById("item-your-affiliation"),
    course: document.getElementById("item-your-course"),
    option: document.getElementById("item-your-option"),
    camera: document.getElementById("item-your-camera"),
    cameraConsult: document.getElementById("item-your-camera-consult-date"),
  };

  const clearControlValue = (control) => {
    if (control.matches('input[type="checkbox"], input[type="radio"]')) {
      control.checked = false;
      return;
    }

    if (control.tagName === "SELECT") {
      control.selectedIndex = 0;
      return;
    }

    control.value = "";
  };

  const setSectionVisible = (section, isVisible, enableControls = true) => {
    if (!section) return;

    section.style.display = isVisible ? "" : "none";
    section.querySelectorAll("input, select, textarea").forEach((control) => {
      if (!isVisible) {
        control.disabled = true;
        clearControlValue(control);
        return;
      }

      if (enableControls) {
        control.disabled = false;
      }
    });
  };

  const isCameraRequested = () => {
    const cameraInput = document.querySelector(
      'input[name="your-camera"]:checked',
    );

    return cameraInput ? cameraInput.value === "あり" : false;
  };

  const syncCameraConsultVisibility = () => {
    setSectionVisible(
      courseFlowSections.cameraConsult,
      Boolean(courseItemEl && courseItemEl.value) && isCameraRequested(),
    );
  };

  const syncCourseFlowVisibility = () => {
    const hasCourseCategory = Boolean(courseCategoryEl && courseCategoryEl.value);
    const hasAffiliation = Boolean(affiliationEl && affiliationEl.value);
    const hasCourseItem = Boolean(courseItemEl && courseItemEl.value);

    setSectionVisible(courseFlowSections.affiliation, hasCourseCategory);
    setSectionVisible(
      courseFlowSections.course,
      hasCourseCategory && hasAffiliation,
    );
    setSectionVisible(
      courseFlowSections.option,
      hasCourseCategory && hasAffiliation && hasCourseItem,
      false,
    );
    setSectionVisible(
      courseFlowSections.camera,
      hasCourseCategory && hasAffiliation && hasCourseItem,
    );
    syncCameraConsultVisibility();
  };

  // 配列から空の値と重複を除き、表示用の候補リストを作ります。
  const uniqueValues = (values) => {
    const collected = [];
    values.forEach((value) => {
      if (value && !collected.includes(value)) {
        collected.push(value);
      }
    });
    return collected;
  };

  // select の空 option に表示する文言を、既存のHTMLから優先して取得します。
  const getBlankOptionText = (select) => {
    if (!select) return "選択してください";
    const blankOption = Array.from(select.options).find(
      (option) => option.value === "",
    );
    return blankOption ? blankOption.textContent : "選択してください";
  };

  // select の選択肢データを、value/label/courseValue の形式にそろえます。
  const normalizeSelectOption = (option) => {
    if (option && typeof option === "object") {
      const value = option.value || option.item || "";
      return {
        value,
        label: option.label || option.item || value,
        courseValue: option.courseValue || option.value || "",
      };
    }

    return {
      value: option,
      label: option,
      courseValue: "",
    };
  };

  // 指定された select の選択肢を作り直し、可能であれば現在の選択値を維持します。
  const setSelectOptions = (select, values, selectedValue) => {
    if (!select) return;

    const blankText = getBlankOptionText(select);
    const selectOptions = values.map(normalizeSelectOption);
    select.innerHTML = "";

    const blankOption = document.createElement("option");
    blankOption.value = "";
    blankOption.textContent = blankText;
    select.appendChild(blankOption);

    selectOptions.forEach((selectOption) => {
      const option = document.createElement("option");
      option.value = selectOption.value;
      option.textContent = selectOption.label;
      if (selectOption.courseValue) {
        option.setAttribute("data-course-value", selectOption.courseValue);
      }
      select.appendChild(option);
    });

    const optionValues = selectOptions.map((selectOption) => {
      return selectOption.value;
    });
    select.value = optionValues.includes(selectedValue) ? selectedValue : "";
  };

  // カテゴリと所属に合うコースだけを、管理画面の設定から絞り込みます。
  const getFilteredCourses = (category, affiliation) => {
    return courseSettings.filter((course) => {
      if (!course || !course.item) return false;
      if (course.hidden) return false;
      if (category && course.category !== category) return false;
      if (affiliation && course.affiliation !== affiliation) return false;
      return true;
    });
  };

  // オプション表示との紐付けに使うコース値を取得します。
  const getCourseValue = (course) => {
    return course && course.value ? course.value : course.item || "";
  };

  // 選択中のコース項目から、オプション判定用のコース値を取得します。
  const getSelectedCourseValue = () => {
    if (!courseItemEl || courseItemEl.value === "") return "";

    const selectedOption =
      courseItemEl.selectedOptions && courseItemEl.selectedOptions[0];
    if (!selectedOption) return courseItemEl.value;

    return (
      selectedOption.getAttribute("data-course-value") || courseItemEl.value
    );
  };

  // 各オプションが紐付くコースを data 属性から取得します。
  const getOptionCourses = (item) => {
    const coursesJson = item.getAttribute("data-courses");
    if (coursesJson) {
      try {
        const courses = JSON.parse(coursesJson);
        if (Array.isArray(courses)) return courses;
      } catch (error) {
        console.error("Option courses JSON parse error:", error);
      }
    }

    const fallbackCourse = item.getAttribute("data-course");
    return fallbackCourse ? [fallbackCourse] : [];
  };

  // 選択されたコースに応じて、オプションの表示/非表示と有効/無効を切り替えます。
  const syncOptions = (courseValue) => {
    const checkboxListItems = document.querySelectorAll(
      ".wpcf7-options .wpcf7-checkbox .wpcf7-list-item",
    );
    const checkboxes = document.querySelectorAll(
      ".wpcf7-options .wpcf7-checkbox input",
    );

    checkboxes.forEach((input) => {
      input.disabled = true;
      input.checked = false;
    });

    checkboxListItems.forEach((item) => {
      const matchesCourse =
        courseValue !== "" && getOptionCourses(item).includes(courseValue);
      item.style.display = matchesCourse ? "block" : "none";

      const input = item.querySelector("input");
      if (input && matchesCourse) {
        input.disabled = false;
      }
    });

    document
      .querySelectorAll(".wpcf7-options > .wpcf7-list-item")
      .forEach((parent) => {
        const hasVisibleItems = Array.from(
          parent.querySelectorAll(".wpcf7-checkbox .wpcf7-list-item"),
        ).some((item) => item.style.display !== "none");

        parent.style.display = hasVisibleItems ? "block" : "none";
      });
  };

  // カテゴリと所属の選択状態に合わせて、コース項目の選択肢を更新します。
  const syncCourseItems = () => {
    const selectedCategory = courseCategoryEl ? courseCategoryEl.value : "";
    const selectedAffiliation = affiliationEl ? affiliationEl.value : "";
    const currentCourse = courseItemEl ? courseItemEl.value : "";
    const courseItems =
      selectedCategory && selectedAffiliation
        ? getFilteredCourses(selectedCategory, selectedAffiliation).map(
          (course) => {
            return {
              value: course.item,
              label: course.item,
              courseValue: getCourseValue(course),
            };
          },
        )
        : [];

    setSelectOptions(courseItemEl, courseItems, currentCourse);
    syncOptions(getSelectedCourseValue());
  };

  // カテゴリの選択状態に合わせて、所属の選択肢を更新します。
  const syncAffiliations = () => {
    const selectedCategory = courseCategoryEl ? courseCategoryEl.value : "";
    const currentAffiliation = affiliationEl ? affiliationEl.value : "";
    const affiliations = selectedCategory
      ? uniqueValues(
        getFilteredCourses(selectedCategory, "").map(
          (course) => course.affiliation,
        ),
      )
      : [];

    setSelectOptions(affiliationEl, affiliations, currentAffiliation);
    syncCourseItems();
  };

  // 個人用フォームのコース選択を、カテゴリ→所属→コース→オプションの順に連動させます。
  const initPersonalCourseControls = () => {
    if (courseCategoryEl && affiliationEl && courseItemEl) {
      courseCategoryEl.addEventListener("change", () => {
        syncAffiliations();
        syncCourseFlowVisibility();
      });
      affiliationEl.addEventListener("change", () => {
        syncCourseItems();
        syncCourseFlowVisibility();
      });
      courseItemEl.addEventListener("change", function () {
        syncOptions(getSelectedCourseValue());
        syncCourseFlowVisibility();
      });
      document
        .querySelectorAll('input[name="your-camera"]')
        .forEach((input) => {
          input.addEventListener("change", syncCameraConsultVisibility);
        });
      syncAffiliations();
      syncCourseFlowVisibility();
    }
  };

  const validateButton = document.querySelector(".js-reservation-validate");
  if (validateButton) {
    const formCheck = document.querySelector(".formCheck");

    // 個人情報同意チェックボックスを取得し、未配置のフォームでは同意済み扱いにします。
    const getAcceptanceInputs = (form) => {
      return Array.from(
        form.querySelectorAll(
          '.formContact__acceptance input[type="checkbox"], .wpcf7-acceptance input[type="checkbox"]',
        ),
      );
    };

    const hasAcceptedPrivacy = (form) => {
      const acceptanceInputs = getAcceptanceInputs(form);
      if (!acceptanceInputs.length) return true;

      return acceptanceInputs.some((input) => input.checked);
    };

    // 同意状態に合わせて確認ボタンの見た目用クラスを付け外しします。
    const syncAcceptanceButtonClass = (form) => {
      if (hasAcceptedPrivacy(form)) {
        validateButton.classList.add("acceptance_ok");
        return true;
      }

      validateButton.classList.remove("acceptance_ok");
      return false;
    };

    // 確認画面へ表示するため、指定フィールドの入力値を配列で取得します。
    const getFieldValues = (form, fieldName) => {
      const fields = Array.from(
        form.querySelectorAll(
          `[name="${fieldName}"], [name="${fieldName}[]"]`,
        ),
      );

      if (!fields.length) return [];

      return fields
        .flatMap((field) => {
          if (field.disabled) return [];

          if (field.matches('input[type="radio"], input[type="checkbox"]')) {
            return field.checked ? [field.value] : [];
          }

          if (field.tagName === "SELECT") {
            return Array.from(field.selectedOptions)
              .filter((option) => option.value !== "")
              .map((option) => option.textContent.trim());
          }

          return field.value ? [field.value.trim()] : [];
        })
        .filter((value) => value !== "");
    };

    // 複数値を確認画面へ表示する際、要素に合わせて安全にテキストとして出力します。
    const setPlaceholderValue = (placeholder, values) => {
      placeholder.textContent = "";

      if (placeholder.matches("ul, ol")) {
        values.forEach((value) => {
          const item = document.createElement("li");

          //SP時値段がある時は改行
          if (value.endsWith("円")) {
            const lastHalf = value.lastIndexOf(" ");
            const lastFull = value.lastIndexOf("　");
            const lastSpaceIndex = Math.max(lastHalf, lastFull);

            if (lastSpaceIndex !== -1) {
              item.innerHTML =
                value.slice(0, lastSpaceIndex) +
                '<br class="sp">' +
                value.slice(lastSpaceIndex + 1);
            } else {
              item.textContent = value;
            }
          } else {
            item.textContent = value;
          }
          placeholder.appendChild(item);
        });
        return;
      }

      values.forEach((value, index) => {
        if (index > 0) {
          placeholder.appendChild(document.createElement("br"));
        }

        placeholder.appendChild(document.createTextNode(value));
      });
    };

    // フォーム入力値を確認画面の同名クラスのプレースホルダー要素に反映します。
    const updateFormCheck = (form) => {
      if (!formCheck) return;

      const fieldNames = new Set();
      const fieldPrefixes = ["your-", "corp-"];
      const placeholders = formCheck.querySelectorAll("span, ul, ol");
      placeholders.forEach((placeholder) => {
        placeholder.classList.forEach((className) => {
          if (fieldPrefixes.some((prefix) => className.startsWith(prefix))) {
            fieldNames.add(className);
          }
        });
      });

      fieldNames.forEach((fieldName) => {
        const values = getFieldValues(form, fieldName);
        placeholders.forEach((placeholder) => {
          if (placeholder.classList.contains(fieldName)) {
            setPlaceholderValue(placeholder, values);
          }
        });
      });
    };

    // 独自バリデーションで追加したエラー表示だけをリセットします。
    const removeCustomValidationErrors = (form) => {
      form.querySelectorAll(".wdrsv-front-not-valid-tip").forEach((tip) => {
        tip.remove();
      });

      form.querySelectorAll("[data-wdrsv-front-invalid]").forEach((field) => {
        field.classList.remove("wpcf7-not-valid");
        field.removeAttribute("aria-invalid");
        field.removeAttribute("data-wdrsv-front-invalid");
      });
    };

    // name 属性からフィールドや値を取得する小さな補助関数です。
    const getNamedField = (form, fieldName) => {
      return form.querySelector(`[name="${fieldName}"]`);
    };

    const getNamedFieldValue = (form, fieldName) => {
      const field = getNamedField(form, fieldName);
      return field ? field.value.trim() : "";
    };

    // Contact Form 7 と同じ見た目になるよう、独自バリデーションエラーを表示します。
    const addCustomValidationError = (field, message) => {
      if (!field) return false;

      field.classList.add("wpcf7-not-valid");
      field.setAttribute("aria-invalid", "true");
      field.setAttribute("data-wdrsv-front-invalid", "true");

      const wrap =
        field.closest(".wpcf7-form-control-wrap") || field.parentElement;
      if (wrap) {
        wrap
          .querySelectorAll(".wdrsv-front-not-valid-tip")
          .forEach((tip) => {
            tip.remove();
          });

        const tip = document.createElement("span");
        tip.className = "wpcf7-not-valid-tip wdrsv-front-not-valid-tip";
        tip.setAttribute("aria-hidden", "true");
        tip.textContent = message;
        wrap.appendChild(tip);
      }

      return true;
    };

    // yyyy-mm-dd の文字列を Date に変換し、存在しない日付は null にします。
    const parseDateValue = (value) => {
      const matches = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!matches) return null;

      const year = Number(matches[1]);
      const month = Number(matches[2]);
      const day = Number(matches[3]);
      const date = new Date(year, month - 1, day);
      date.setHours(0, 0, 0, 0);

      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        return null;
      }

      return date;
    };

    // 管理画面の予約可能日設定から、選択できる最短日を算出します。
    const getMinSelectableDate = () => {
      let offsetValue = parseInt(wdSettings.offsetValue, 10);
      if (isNaN(offsetValue) || offsetValue < 1) offsetValue = 3;

      const offsetUnit = wdSettings.offsetUnit || "day";
      const minDate = new Date();
      minDate.setHours(0, 0, 0, 0);

      switch (offsetUnit) {
        case "week":
          minDate.setDate(minDate.getDate() + offsetValue * 7);
          break;
        case "month":
          minDate.setMonth(minDate.getMonth() + offsetValue);
          break;
        case "year":
          minDate.setFullYear(minDate.getFullYear() + offsetValue);
          break;
        default:
          minDate.setDate(minDate.getDate() + offsetValue);
          break;
      }

      return minDate;
    };

    // Contact Form 7 標準チェック後に、ふりがな・メール確認・希望日を追加チェックします。
    const validateCustomFields = (form) => {
      let hasError = false;

      const furiganaField = getNamedField(form, "your-furigana");
      const furigana = furiganaField ? furiganaField.value.trim() : "";
      if (furigana && !/^[ア-ヶーぁ-ん\s\u3000]+$/u.test(furigana)) {
        hasError =
          addCustomValidationError(
            furiganaField,
            "全角カタカナ又は平仮名で入力してください。",
          ) || hasError;
      }

      const emailPairs = [
        {
          email: "your-email",
          confirm: "your-email-confirm",
        },
        {
          email: "corp-email",
          confirm: "corp-email-confirm",
        },
      ];
      emailPairs.forEach((pair) => {
        const email = getNamedFieldValue(form, pair.email);
        const emailConfirmField = getNamedField(form, pair.confirm);
        const emailConfirm = emailConfirmField
          ? emailConfirmField.value.trim()
          : "";

        if (emailConfirm && email !== emailConfirm) {
          hasError =
            addCustomValidationError(
              emailConfirmField,
              "メールアドレスが一致していません。",
            ) || hasError;
        }
      });

      if (isCameraRequested()) {
        [
          {
            field: "your-camera-consult-date1",
            message: "大腸カメラ事前診察希望日の第一希望日を選択してください。",
          },
          {
            field: "your-camera-consult-time1",
            message: "大腸カメラ事前診察希望日の第一希望時間を選択してください。",
          },
          {
            field: "your-camera-consult-date2",
            message: "大腸カメラ事前診察希望日の第二希望日を選択してください。",
          },
          {
            field: "your-camera-consult-time2",
            message: "大腸カメラ事前診察希望日の第二希望時間を選択してください。",
          },
        ].forEach((requiredField) => {
          const field = getNamedField(form, requiredField.field);
          if (!field || field.disabled || field.value.trim()) return;

          hasError =
            addCustomValidationError(field, requiredField.message) || hasError;
        });
      }

      const holidays = Array.isArray(wdSettings.holidays)
        ? wdSettings.holidays
        : [];
      const minDate = getMinSelectableDate();
      const unitLabels = {
        day: "日",
        week: "週間",
        month: "ヶ月",
        year: "年",
      };
      const offsetValue = parseInt(wdSettings.offsetValue, 10);
      const validOffsetValue =
        isNaN(offsetValue) || offsetValue < 1 ? 3 : offsetValue;
      const offsetUnit = wdSettings.offsetUnit || "day";
      const offsetLabel = unitLabels[offsetUnit] || "日";

      personalDateFieldNames.forEach((fieldName) => {
        const dateField = getNamedField(form, fieldName);
        if (!dateField || !dateField.value.trim()) return;

        const dateValue = dateField.value.trim();
        const date = parseDateValue(dateValue);
        if (!date) {
          hasError =
            addCustomValidationError(
              dateField,
              "日付の形式が正しくありません。",
            ) || hasError;
          return;
        }

        if (holidays.includes(dateValue)) {
          hasError =
            addCustomValidationError(
              dateField,
              "休日はご選択いただけません。",
            ) || hasError;
          return;
        }

        if (date < minDate) {
          hasError =
            addCustomValidationError(
              dateField,
              `${validOffsetValue}${offsetLabel}後以降の日付をご選択ください。`,
            ) || hasError;
        }
      });

      return hasError;
    };

    // エラーがある場合は、最初のエラー項目までスクロールして入力し直しやすくします。
    const scrollToFirstInvalid = (form) => {
      const firstInvalid = form.querySelector(".wpcf7-not-valid");
      if (!firstInvalid) return false;

      const scrollTarget =
        firstInvalid.closest(".formContact__item") || firstInvalid;
      scrollTarget.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      if (typeof firstInvalid.focus === "function") {
        firstInvalid.focus({ preventScroll: true });
      }

      return true;
    };

    // 同意チェックの変更に合わせて、確認ボタンの状態を即時更新します。
    const currentForm = validateButton.closest("form.wpcf7-form");
    if (currentForm) {
      getAcceptanceInputs(currentForm).forEach((input) => {
        input.addEventListener("change", () => {
          syncAcceptanceButtonClass(currentForm);
        });
      });
      syncAcceptanceButtonClass(currentForm);
    }

    // 確認画面の「戻る」ボタンで、確認画面表示クラスを外して入力画面へ戻します。
    document.querySelectorAll(".formCheck .btn-back,.formCheckContent__close").forEach((button) => {
      button.addEventListener("click", () => {
        if (formCheck) {
          formCheck.classList.remove("check_open");
        }
      });
    });

    // 確認ボタン押下時に標準/独自バリデーションを通し、問題なければ確認画面を開きます。
    validateButton.addEventListener("click", function () {
      const form = this.closest("form.wpcf7-form");
      if (
        !form ||
        !window.wpcf7 ||
        typeof window.wpcf7.validate !== "function"
      ) {
        return;
      }

      if (formCheck) {
        formCheck.classList.remove("check_open");
      }

      removeCustomValidationErrors(form);

      if (!syncAcceptanceButtonClass(form)) {
        alert("個人情報の取り扱いについて同意してください。");
        return;
      }

      window.wpcf7.validate(form);

      window.setTimeout(() => {
        validateCustomFields(form);
        if (scrollToFirstInvalid(form)) return;

        if (formCheck) {
          updateFormCheck(form);
          formCheck.classList.add("check_open");
        }
      }, 0);
    });
  }

  // 個人用・法人用それぞれの郵便番号と住所フィールドの組み合わせです。
  const postalAddressPairs = [
    {
      postal: "your-postal",
      address: "your-address",
    },
    {
      postal: "corp-postal",
      address: "corp-address",
    },
  ];

  // 郵便番号が7桁になったら zipcloud で住所を検索し、住所欄へ自動入力します。
  postalAddressPairs.forEach((pair) => {
    const postalInput = document.querySelector(
      `[data-name="${pair.postal}"] input`,
    );
    if (!postalInput) return;

    postalInput.addEventListener("blur", function () {
      const zip = this.value.replace(/[^0-9]/g, "");
      if (zip.length !== 7) return;

      fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`)
        .then((res) => res.json())
        .then((data) => {
          const addressInput = document.querySelector(
            `[data-name="${pair.address}"] input`,
          );
          if (data.results && addressInput) {
            const result = data.results[0];
            addressInput.value =
              result.address1 + " " + result.address2 + " " + result.address3;
          } else if (!data.results) {
            alert("郵便番号が見つかりませんでした");
          }
        })
        .catch(() => alert("住所検索に失敗しました"));
    });
  });

  // 個人用フォームの希望日フィールドに flatpickr を適用し、選択可能日と休日を制御します。
  const initPersonalDatePickers = () => {
    const dateContainers = document.querySelectorAll(
      personalDateFieldNames
        .map((fieldName) => `[data-name="${fieldName}"]`)
        .join(", "),
    );
    dateContainers.forEach((el) => {
      el.classList.add("flatpickr");
    });

    let offsetValue = parseInt(wdSettings.offsetValue, 10);
    if (isNaN(offsetValue) || offsetValue < 1) offsetValue = 3;

    const offsetUnit = wdSettings.offsetUnit || "day";
    const holidays = Array.isArray(wdSettings.holidays)
      ? wdSettings.holidays
      : [];

    const minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    switch (offsetUnit) {
      case "week":
        minDate.setDate(minDate.getDate() + offsetValue * 7);
        break;
      case "month":
        minDate.setMonth(minDate.getMonth() + offsetValue);
        break;
      case "year":
        minDate.setFullYear(minDate.getFullYear() + offsetValue);
        break;
      default:
        minDate.setDate(minDate.getDate() + offsetValue);
        break;
    }

    if (typeof flatpickr !== "undefined") {
      flatpickr(
        personalDateFieldNames
          .map((fieldName) => `.wpcf7-date[name="${fieldName}"]`)
          .join(", "),
        {
          dateFormat: "Y-m-d",
          minDate,
          static: true,
          // 休日は管理画面で登録したものだけを無効化（土日の自動無効化は廃止）
          disable: holidays,
          onDayCreate: (...args) => {
            const dayElem = args[3];
            if (!dayElem || !dayElem.dateObj) return;

            const dayOfWeek = dayElem.dateObj.getDay();

            if (dayOfWeek === 6) {
              dayElem.classList.add("is-saturday");
            } else if (dayOfWeek === 0) {
              dayElem.classList.add("is-sunday");
            }
          },
        },
      );
    }
  };

  // 確認画面のオプション表示は、カンマ区切りを改行に置き換えて見やすくします。
  const formatPersonalConfirmOptions = () => {
    const confirmOptions = document.querySelector(
      ".formContact__confirm--options",
    );
    if (confirmOptions) {
      confirmOptions.innerHTML = confirmOptions.innerHTML.replace(
        /, /g,
        "<br>",
      );
    }
  };


  // 数字入力だけ許可するフィールドでは、入力中に数字以外を取り除きます。
  document.querySelectorAll('.js-only-num').forEach(element => {
    element.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '');
    });
  });

  // 電話番号など、数字とハイフンだけ許可するフィールドの入力を整えます。
  document.querySelectorAll('.js-only-num-hyphen').forEach(element => {
    element.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9-]/g, '');
    });
  });

  if (isPersonalForm) {
    // 個人用フォームだけ、コース連動・希望日カレンダー・確認画面整形を初期化します。
    initPersonalCourseControls();
    initPersonalDatePickers();
    formatPersonalConfirmOptions();
  }
});

// Contact Form 7 Multi-Step の復元後にも、コース選択の連動状態を再同期します。
window.addEventListener("load", () => {
  if (!document.getElementById("for_personal")) return;

  const courseCategoryEl = document.querySelector(".wpcf7-courses");
  if (courseCategoryEl) {
    setTimeout(() => {
      courseCategoryEl.dispatchEvent(new Event("change"));
    }, 1000);
  }
});

// 送信完了後は、予約完了ページへ遷移します。
document.addEventListener('wpcf7mailsent', function () {
  location = './thanks/';
}, false);
